module.exports = __webpack_public_path__ + "img/58.dd1b1031.jpg";